import * as React from 'react'

import * as Types from '../../declarations'
import TitleOverview from './Overview'
import Itinerary from './Itinerary'
import Weather from './Weather'
import Gear from './Gear'
import Services from './Services'
import Accomodation from './Accomodation'
import Permits from './Permits'
import Access from './Access'
import History from './History'
import Videos from './Videos'
import Variations from './Variations'
import Similar from './Similar'
import FAQs from './FAQs'
import Groups from './Groups'
import SummitView from './SummitView'
import Guides from './Guides'
import Route from './Route'
import Difficulty from './Difficulty'
import AccountNudge from 'components/AccountNudge'

const FullTripPage = ({
	trip,
	version,
	isAdSource,
}: {
	trip: Types.DB.Models.TripAttributes
	version: Types.VERSION
	isAdSource: boolean
}) => {
	return (
		<div id="trek-page">
			<div style={{ marginBottom: '10px' }}>
				<AccountNudge variant="alert" version={version} />
			</div>
			<TitleOverview trip={trip} />
			<Guides trip={trip} version={version} isAdSource={isAdSource} />
			<History trip={trip} />
			<Itinerary trip={trip} />
			{/* <RouteMap trip={trip} /> */}
			{/* // todo: altitude profile */}
			<Route trip={trip} />
			<Difficulty trip={trip} />
			<Weather trip={trip} />
			<Gear trip={trip} />
			<Services trip={trip} />
			<Accomodation trip={trip} />
			<Permits trip={trip} />
			<Access trip={trip} />
			<Videos trip={trip} />
			<SummitView trip={trip} />
			<Variations trip={trip} />
			<FAQs trip={trip} />
			{/* // todo: blogs & stories */}
			<Groups trip={trip} />
			{/* // todo: recent photos */}
			<Similar trip={trip} />
			<div
				style={{
					marginBottom: 200,
				}}
			></div>
		</div>
	)
}

export default FullTripPage
